"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publishResizedImagePath = exports.publicUploadPath = void 0;
exports.publicUploadPath = '/uploads';
exports.publishResizedImagePath = '/resized';
//# sourceMappingURL=ServerPaths.js.map